import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './index.scss';

class UnreadWrapper extends Component {
  static propTypes = {
    hasUnread: PropTypes.bool,
    children: PropTypes.element,
  };

  render() {
    return (
      <div
        className={`UnreadWrapper ${
          this.props.hasUnread ? 'UnreadWrapper-unread' : ''
        }`}
      >
        {this.props.children}
      </div>
    );
  }
}

export default UnreadWrapper;
